let translateAPROF = {
	newsletterTitle: 'Newsletter',
	newsletterSubtitle: 'newsletter subtitle'
};

export default translateAPROF;
